export default __webpack_public_path__ + "images/co.e894357c52fbf171977a7bbcf5409250.png";